import { render, staticRenderFns } from "./TreeSelector.vue?vue&type=template&id=3dae4cff&scoped=true"
import script from "./TreeSelector.vue?vue&type=script&lang=js"
export * from "./TreeSelector.vue?vue&type=script&lang=js"
import style0 from "./TreeSelector.vue?vue&type=style&index=0&id=3dae4cff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae4cff",
  null
  
)

export default component.exports